import React from "react";
import { Main } from "../../admin/Dashboard/styled";
import { Row } from "antd";
import { Cards } from "../../common/frame/cards-frame";
import RoyalStatistics from "./RoyalStatistics";
import RoyalTopMasters from "./RoyalTopMasters";
import RoyalProductSales from "./RoyalProductSales";

function RoyalDashboard() {
  return (
    <>
      <div
        style={{ background: "#eef1ff", marginTop: "-0.4rem" }}
        className="p-3"
      >
        <RoyalStatistics />
        <Main>
          <Row>
            <div className="wrapper-container-full">
              <div className="masters-container">
                <Cards
                  headStyle={{ fontSize: 14 }}
                  title="Топ 10 мастеров по продажам"
                  bodypadding="0"
                >
                  <RoyalTopMasters />
                </Cards>
              </div>
            </div>
            <div className="wrapper-container-full">
              <div className="products-container">
                <Cards
                  headStyle={{ fontSize: 14 }}
                  title="Продажа по моделям"
                  bodypadding="0"
                >
                  <RoyalProductSales />
                </Cards>
              </div>
            </div>
          </Row>
        </Main>
      </div>
    </>
  );
}

export default RoyalDashboard;
